// carData.js

const taxiData = [
  {
    id: 1,
    name: "Mazda Axela 1.5 liter",
    driver: "James Bond",
    price: "800",
    seating: "5 Seater",
    image: "./assets/images/car-0.png",
    phone: "0791 871 179",
  },
  {
    id: 2,
    name: "Toyota XT Black",
    driver: "Ann Vies",
    price: "1,200",
    seating: "7 Seater",
    image: "./assets/images/car-3.png",
    phone: "0791 871 179",
  },
  {
    id: 3,
    name: "Toyota Insight New Model",
    driver: "Ann Vies",
    price: "1,200",
    seating: "7 Seater",
    image: "./assets/images/car-5.png",
    phone: "0791 871 179",
  },
];

export default taxiData;
